import styled from "styled-components"

const Wrapper = styled.div`
  margin-top: 10px;
  position: absolute;
  width: calc(100% - 88px);

  .emoji-mart .emoji-mart-bar {
    display: none;
  }

  .emoji-mart .emoji-mart-scroll {
    height: 126px;
  }
`

export default Wrapper
